import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { DownloadOutlined } from "@ant-design/icons";
import React, {
  useMemo,
  useState,
} from "react";

import axios from "axios";

import BASE_URL from "../../services/service";

import {
  Layout,
  Card,
  Typography,
  Input,
  Button,
  Table,
  Space,
  Tag,
  Modal,
  Spin,
  Row,
  Col,
  message,
  Select,
} from "antd";

import {
  EyeOutlined,
  SearchOutlined,
  LockOutlined,
  UserOutlined,
} from "@ant-design/icons";

const { Content } = Layout;

const { Title, Text } =
  Typography;

const USERNAME =
  "radhadamodar";

const PASSWORD =
  "VrN9@kL2#Px7";

const PAPER_OPTIONS = [
  {
    label:
      "Teachings Of Prahlad Maharaj",
    value: "6852a123456",
  },
  {
    label:
      "Rasraj Sri Krishna",
    value: "6852a999999",
  },
   {
    label:
      "On the way to Krishna",
    value: "6852a1239991",
  },
   {
    label:
      "Krisna Consciousness - The Matchless Gift",
    value: "61252a1238562",
  },
  {
    label:
      "Perfection of Yoga",
    value: "9900221122",
  },
  {
    label:
      "Beyond Birth and Death",
    value: "363723762213787",
  },
];

export default function AdminPortal() {
  const [username, setUsername] =
    useState("");

  const [password, setPassword] =
    useState("");

  const [authenticated,
    setAuthenticated,
  ] = useState(false);

  const [loading, setLoading] =
    useState(false);

  const [students, setStudents] =
    useState([]);

  const [search, setSearch] =
    useState("");

  const [selectedPaper,
    setSelectedPaper,
  ] = useState("6852a123456");

  const [answersModal,
    setAnswersModal,
  ] = useState(false);

  const [selectedStudent,
    setSelectedStudent,
  ] = useState(null);

  const [answers,
    setAnswers,
  ] = useState([]);

  const handleLogin = async () => {
    if (
      username === USERNAME &&
      password === PASSWORD
    ) {
      setAuthenticated(true);

      await fetchResults(
        selectedPaper
      );

      return;
    }

    message.error(
      "Invalid Credentials"
    );
  };

  const downloadPDF = () => {
  const doc = new jsPDF("p", "mm", "a4");

  const examName =
    PAPER_OPTIONS.find(
      (p) => p.value === selectedPaper
    )?.label || "Examination";

  // Sort by percentage DESC
  const sortedStudents = [...filteredStudents].sort((a, b) => {
    if (b.percentage !== a.percentage) {
      return b.percentage - a.percentage;
    }

    return b.obtainedMarks - a.obtainedMarks;
  });

  // Heading
  // Blue banner
doc.setFillColor(25, 118, 210);
doc.roundedRect(8, 8, 194, 24, 3, 3, "F");

// Main title
doc.setTextColor(255, 255, 255);
doc.setFont("times", "bold");
doc.setFontSize(22);
doc.text("Examination Results", 105, 18, {
  align: "center",
});

// Subtitle
doc.setFont("helvetica", "italic");
doc.setFontSize(12);
doc.text(`Marks for ${examName}`, 105, 26, {
  align: "center",
});

doc.setTextColor(40);

  autoTable(doc, {
    startY: 35,

    head: [[
      "Rank",
      "Name",
      "Mobile Number",
      "Marks",
      "Percentage"
    ]],

    body: sortedStudents.map((student, index) => [
      index + 1,
      student.fullName,
      student.mobile,
      `${student.obtainedMarks}/${student.totalMarks}`,
      `${student.percentage}%`,
    ]),

    styles: {
    font: "helvetica",
    fontSize: 10,
    cellPadding: 4,
    lineWidth: 0.2,
  },

  headStyles: {
    fillColor: [33, 150, 243],
    textColor: 255,
    fontStyle: "bold",
    fontSize: 11,
  },

  alternateRowStyles: {
    fillColor: [245, 247, 250],
  },

    columnStyles: {
      1: {
        halign: "left",
      },
    },

    margin: {
      left: 10,
      right: 10,
    },
  });

  doc.save(
    `${examName.replace(/\s+/g, "_")}_Results.pdf`
  );
};

  const fetchResults =
    async (paperId) => {
      try {
        setLoading(true);

        const res =
          await axios.get(
            `${BASE_URL}/all-results`,
            {
              params: {
                paperId,
              },
            }
          );

        if (res.data.success) {
          setStudents(
            res.data.results || []
          );
        }
      } catch (err) {
        console.log(err);

        message.error(
          "Failed to fetch results"
        );
      } finally {
        setLoading(false);
      }
    };

  const fetchAnswers =
    async (student) => {
      try {
        setLoading(true);

        const res =
          await axios.get(
            `${BASE_URL}/student-answers/${student.studentId}`,
            {
              params: {
                paperId:
                  selectedPaper,
              },
            }
          );

        if (res.data.success) {
          setSelectedStudent(
            res.data.student
          );

          setAnswers(
            res.data.answers || []
          );

          setAnswersModal(
            true
          );
        }
      } catch (err) {
        console.log(err);

        message.error(
          "Failed to fetch answers"
        );
      } finally {
        setLoading(false);
      }
    };

  const filteredStudents =
    useMemo(() => {
      return students.filter(
        (student) =>
          student.fullName
            ?.toLowerCase()
            .includes(
              search.toLowerCase()
            ) ||
          student.mobile
            ?.toLowerCase()
            .includes(
              search.toLowerCase()
            ) ||
          student.devoteeId
            ?.toLowerCase()
            .includes(
              search.toLowerCase()
            )
      );
    }, [students, search]);

  const columns = [
    {
      title: "Name",

      dataIndex: "fullName",

      width: 220,
    },

    {
      title: "Mobile",

      dataIndex: "mobile",

      width: 140,
    },

    {
      title: "Devotee ID",

      dataIndex: "devoteeId",

      width: 140,
    },

    {
      title: "Paper",

      width: 220,

      render: (_, record) => (
        <Tag color="purple">
          {record.paperName ||
            "N/A"}
        </Tag>
      ),
    },

    {
      title: "Marks",

      width: 120,

      render: (_, record) => (
        <Tag color="blue">
          {
            record.obtainedMarks
          }
          /
          {
            record.totalMarks
          }
        </Tag>
      ),
    },

    {
      title: "Percentage",

      width: 120,

      render: (_, record) => (
        <Tag color="green">
          {
            record.percentage
          }
          %
        </Tag>
      ),
    },

    {
      title: "Status",

      width: 140,

      render: (_, record) => (
        <Tag
          color={
            record.examCompleted
              ? "green"
              : "red"
          }
        >
          {record.examCompleted
            ? "Completed"
            : "Pending"}
        </Tag>
      ),
    },

    {
      title: "Actions",

      width: 180,

      render: (_, record) => (
        <Button
          type="primary"
          icon={<EyeOutlined />}
          onClick={() =>
            fetchAnswers(
              record
            )
          }
        >
          View Answers
        </Button>
      ),
    },
  ];

  if (!authenticated) {
    return (
      <Layout
        style={{
          minHeight: "100vh",
          background:
            "linear-gradient(135deg,#667eea 0%,#764ba2 100%)",
        }}
      >
        <Content
          style={{
            display: "flex",
            justifyContent:
              "center",
            alignItems:
              "center",
            padding: 20,
          }}
        >
          <Card
            style={{
              width: 420,
              borderRadius: 24,
            }}
          >
            <Space
              direction="vertical"
              size={20}
              style={{
                width: "100%",
              }}
            >
              <div
                style={{
                  textAlign:
                    "center",
                }}
              >
                <Title level={2}>
                  Admin Login
                </Title>

                <Text type="secondary">
                  Examination Admin
                  Portal
                </Text>
              </div>

              <Input
                size="large"
                placeholder="Username"
                prefix={
                  <UserOutlined />
                }
                value={username}
                onChange={(e) =>
                  setUsername(
                    e.target.value
                  )
                }
              />

              <Input.Password
                size="large"
                placeholder="Password"
                prefix={
                  <LockOutlined />
                }
                value={password}
                autoComplete="current-password"
                onChange={(e) =>
                  setPassword(
                    e.target.value
                  )
                }
                onPaste={(e) => {
                  const pastedText =
                    e.clipboardData.getData(
                      "text"
                    );

                  setPassword(
                    pastedText
                  );
                }}
                onPressEnter={
                  handleLogin
                }
              />

              <Button
                type="primary"
                size="large"
                block
                onClick={
                  handleLogin
                }
              >
                Login
              </Button>
            </Space>
          </Card>
        </Content>
      </Layout>
    );
  }

  return (
    <Layout
      style={{
        minHeight: "100vh",
        background:
          "#f5f7fb",
      }}
    >
      <Content
        style={{
          padding: 24,
        }}
      >
     <Row
  gutter={[16, 16]}
  justify="space-between"
  align="middle"
>
  <Col xs={24} md={8}>
    <Title
      level={2}
      style={{ marginBottom: 0 }}
    >
      Examination Results
    </Title>
  </Col>

  <Col xs={24} md={6}>
    <Select
      size="large"
      value={selectedPaper}
      style={{ width: "100%" }}
      options={PAPER_OPTIONS}
      onChange={async (value) => {
        setSelectedPaper(value);
        await fetchResults(value);
      }}
    />
  </Col>

  <Col xs={24} md={6}>
    <Input
      size="large"
      placeholder="Search..."
      prefix={<SearchOutlined />}
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />
  </Col>

  <Col
    xs={24}
    md={4}
    style={{
      display: "flex",
      justifyContent: "flex-end",
    }}
  >
   <Button
  type="primary"
  icon={<DownloadOutlined />}
  size="large"
  style={{
    width: 44,
    height: 44,
    borderRadius: 12,
  }}
  onClick={downloadPDF}
/>
  </Col>
</Row>

        <Card
          style={{
            marginTop: 20,
            borderRadius: 20,
          }}
        >
          <Spin spinning={loading}>
            <Table
              rowKey={(
                record
              ) =>
                `${record.studentId}_${record.paperId}`
              }
              columns={columns}
              dataSource={[...filteredStudents].sort((a, b) => {
  if (b.percentage !== a.percentage) {
    return b.percentage - a.percentage;
  }

  return b.obtainedMarks - a.obtainedMarks;
})}
              scroll={{
                x: 1200,
              }}
              pagination={{
                pageSize: 10,
              }}
            />
          </Spin>
        </Card>

        <Modal
          open={answersModal}
          onCancel={() => {
            setAnswersModal(
              false
            );

            setAnswers([]);

            setSelectedStudent(
              null
            );
          }}
          footer={null}
          width={1000}
          title={`Answer Sheet - ${selectedStudent?.fullName || ""
            }`}
        >
          <Space
            direction="vertical"
            size={16}
            style={{
              width: "100%",
            }}
          >
            {answers.length ===
              0 && (
                <Text>
                  No answers found.
                </Text>
              )}

            {answers.map(
              (
                answer,
                index
              ) => (
                <Card
                  key={index}
                  style={{
                    borderRadius: 16,
                    border:
                      answer.isCorrect
                        ? "1px solid #b7eb8f"
                        : "1px solid #ffa39e",
                  }}
                >
                  <Space
                    direction="vertical"
                    style={{
                      width: "100%",
                    }}
                  >
                    <Title level={5}>
                      Q
                      {index + 1}
                      .{" "}
                      {
                        answer.question
                      }
                    </Title>

                    <div>
                      {answer.options?.map(
                        (
                          opt,
                          i
                        ) => (
                          <Tag
                            key={i}
                            color={
                              i ===
                                answer.correctAnswer
                                ? "green"
                                : i ===
                                  answer.selectedAnswer
                                  ? "red"
                                  : "default"
                            }
                            style={{
                              padding:
                                "6px 12px",
                              marginBottom: 8,
                              display:
                                "inline-block",
                            }}
                          >
                            {opt}
                          </Tag>
                        )
                      )}
                    </div>

                    <Text strong>
                      Selected
                      Answer:{" "}
                      {typeof answer.selectedAnswer ===
                        "number"
                        ? answer.selectedAnswer +
                        1
                        : "N/A"}
                    </Text>

                    <Text strong>
                      Correct
                      Answer:{" "}
                      {typeof answer.correctAnswer ===
                        "number"
                        ? answer.correctAnswer +
                        1
                        : "N/A"}
                    </Text>

                    <Tag
                      color={
                        answer.isCorrect
                          ? "green"
                          : "red"
                      }
                    >
                      {answer.isCorrect
                        ? "Correct"
                        : "Wrong"}
                    </Tag>
                  </Space>
                </Card>
              )
            )}
          </Space>
        </Modal>
      </Content>
    </Layout>
  );
}